import React, { useEffect } from 'react';
import { useNavigate, Link, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import './admin.scss';

function ProfilesSection() {
  return (
    <div className="admin-section">
      <h3>Profiles</h3>
      <p>Profiles management will be implemented next.</p>
    </div>
  );
}

export default function AdminDashboard() {
  const { adminUser, logout } = useAdminAuth();
  const navigate = useNavigate();

  // Ensure body scrolling is enabled when Admin loads
  useEffect(() => {
    const body = document.body;
    // Remove any modal-open class that might be stuck on body
    body.classList.remove('modal-open');
    // Ensure body is scrollable
    body.style.overflow = 'auto';
    body.style.position = 'static';
    body.style.width = 'auto';
    body.style.height = 'auto';

    return () => {
      // Cleanup only resets to defaults, does not re-apply modal lock
      body.style.overflow = '';
      body.style.position = '';
      body.style.width = '';
      body.style.height = '';
    };
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="brand">YLIVED Admin</div>
        <nav>
          <ul>
            {/* Use relative links so nested routing works reliably */}
            <li><Link to="profiles">Profiles</Link></li>
            <li><Link to="channels">Channels</Link></li>
            <li><Link to="spot-prices">Spot Prices</Link></li>
            <li><Link to="payment-links">Payment Links</Link></li>
            <li><Link to="bulk-upload">Bulk Upload</Link></li>
            <li><Link to="profile-fixer">Profile Fixer</Link></li>
          </ul>
        </nav>
        <button className="logout-button" onClick={handleLogout}>Logout</button>
      </aside>
      <main className="admin-main">
        <header className="admin-header">
          <h2>Admin Dashboard</h2>
          <div className="admin-user">{adminUser?.email}</div>
        </header>
        <section className="admin-content">
          <Outlet />
        </section>
      </main>
    </div>
  );
}
